__turbopack_context__.v({
  "article-body": "Ik8DHW_article-body",
  "good-to-know": "Ik8DHW_good-to-know",
  "image": "Ik8DHW_image",
  "landscape": "Ik8DHW_landscape",
  "portrait": "Ik8DHW_portrait",
  "quote": "Ik8DHW_quote",
  "quote-wrapper": "Ik8DHW_quote-wrapper",
  "rich-text": "Ik8DHW_rich-text",
  "table": "Ik8DHW_table",
  "video": "Ik8DHW_video",
  "video-wrapper": "Ik8DHW_video-wrapper",
  "vimeo": "Ik8DHW_vimeo",
});
